import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { PaymethodWizardStore, PaymethodWizardState } from './paymethod-wizard.store';
import { PaymethodWizard } from './paymethod-wizard.model';

@Injectable({
  providedIn: 'root'
})
export class PaymethodWizardQuery extends QueryEntity<PaymethodWizardState, PaymethodWizard> {

  constructor(protected store: PaymethodWizardStore) {
    super(store);
  }

}
